import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const PDPAccordionPanelDetails = ({
    children,
    className = "",
    isExpanded = true,
    desktopCollapsible = true,
    smartphoneCollapsible = true,
    smartphoneWidth = 991,
    id,
    initialHeight = 0,
}) => {
    const [isStateExpanded, setExpanded] = React.useState(false);
    React.useEffect(() => {
        setExpanded(isExpanded);
    }, [isExpanded]);
    
    const styleClass = isStateExpanded
        ? { height: initialHeight }
        : { height: 0 };

    return (
        <div className={classNames("h-full md:max-h-[600px] relative", className)}>
            <div
                id={id}
                style={styleClass}
                className={`border-b-1 border-themeYellow overflow-hidden transition-all ease-out duration-500 ${
                    isStateExpanded &&
                    "relative w-full z-1 bg-white pb-6  lg:pb-16  "
                }`}
            >
                {children}
            </div>
        </div>
    );
};

export default PDPAccordionPanelDetails;

PDPAccordionPanelDetails.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    isExpanded: PropTypes.bool.isRequired,
    desktopCollapsible: PropTypes.bool,
    smartphoneCollapsible: PropTypes.bool,
    smartphoneWidth: PropTypes.number,
    id: PropTypes.string,
    initialHeight: PropTypes.number,
};

